function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "preview_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "preview_svg__a",
  transform: "translate(47 260.7)",
  d: "M0 0h16v16H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "preview_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "preview_svg__c",
  d: "M2 11.125a8.409 8.409 0 01-2-3.17h.867a7.684 7.684 0 002.778 3.487 7.662 7.662 0 008.715 0 7.685 7.685 0 002.777-3.487H16a8.5 8.5 0 01-8 5.655 8.428 8.428 0 01-6-2.485zm2.847-3.171a3.231 3.231 0 113.232 3.232 3.235 3.235 0 01-3.232-3.232zm.808 0a2.424 2.424 0 102.424-2.423 2.427 2.427 0 00-2.424 2.423zm9.482 0a7.677 7.677 0 00-14.27 0H0A8.5 8.5 0 018 2.3a8.5 8.5 0 018 5.654z"
}));

function SvgPreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgPreview;